<template>
  <!-- 追加 -->
  <div class="firm-body">
    <!-- 标题  -->
    <p class="title-Individual-center">
      <span class="firm-clickable" @click="handelReturn">人才资源管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="firm-clickable" @click="handelReturn">文件库管理</span>
      <i class="el-icon-arrow-right"></i>
      <span class="firm-clickable" @click="handelPreviousPage">{{ Information.name }}（离职）</span>
      <i class="el-icon-arrow-right"></i>
      <span class="span-Individual-center">{{ routeName }}</span>
    </p>
    <div class="box">
      <div style="float: right; margin-top: 20px">
        <div
          v-if="
            Information.applyForEvaluate == null ||
            Information.applyForEvaluate.length == 0
          "
          class="blue-button"
          style="width: 150px; font-size: 14px; height: 35px"
          @click="dialogUpload = true"
        >
          上传职场信用申请书
        </div>
        <div
          v-else
          class="blue-button"
          style="width: 170px; font-size: 14px; height: 35px"
          @click="handelDownload(CreditEvaluation.applyForEvaluate)"
        >
          职场信用申请书已上传
        </div>
      </div>
      <div class="box-title" style="margin-top: 10px">
        <span>基本信息</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>

      <div class="information">
        <div class="left">
          <div class="left-img">
            <img src="@/assets/imgs/tx1@3x.svg" alt="" />
          </div>
          <div class="left-text">
            <div>
              <span style="font-size: 20px; color: #333; font-weight: 400">{{
                Information.name
              }}</span>
              <span>{{ Information.sex == 0 ? "女" : "男" }}</span>
              <span></span>
              <span>出生日期：{{ Information.birthday }}</span>
            </div>
            <div
              style="margin-top: 20px; justify-content: start"
              class="flex-box"
            >
              <div class="flex-box" style="justify-content: start">
                <img src="@/assets/imgs/dianhua-weijiaohuan@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ Information.phone }}</span>
              </div>
              <div class="flex-box" style="justify-content: start">
                <img src="@/assets/imgs/youxiang@3x.svg" alt="" />
                <span style="margin-left: 10px">{{ Information.mail }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div>
            <span>所在部门：{{ Information.department }}</span>
            <span style="margin-left: 20px"
              >所在职位：{{ Information.positionName }}</span
            >
          </div>
          <div style="margin-top: 20px">
            <span
              >在职时间：{{ Information.jobStartTime }} ——
              {{
                Information.leaveTime != null ? Information.leaveTime : "至今"
              }}</span
            >
          </div>
        </div>
      </div>
      <div style="display: flex; align-items: center">
        <div class="box-title">
          <span>打分表</span>
          <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
        </div>
        <!-- <div style="font-size: 16px; color: #999999">（评价人：李三）</div> -->
      </div>
      <div>
        <el-table
          :data="tableData"
          border
          stripe
          style="width: 100%"
          :cell-style="{ textAlign: 'center' }"
          :header-cell-style="{
            background: '#409eff ',
            textAlign: 'center',
            color: '#ffffff',
            padding: '3px',
            fontSize: '16px',
            fontWeight: '400',
            height: '45px',
            border: 0,
          }"
          :span-method="arraySpanMethod"
        >
          <el-table-column prop="date" label="评内容" width="120">
          </el-table-column>
          <el-table-column prop="name" label="评价指标" width="120">
          </el-table-column>
          <el-table-column
            prop="address"
            label="指标描述"
            style="text-align: left"
          >
          </el-table-column>
          <el-table-column prop="sum" label="总分值" width="80">
          </el-table-column>
          <el-table-column prop="address" label="评分" width="320">
            <template slot-scope="scope">
              <div class="pf-box" v-if="scope.row.sum == 10">
                <div
                  :class="
                    scope.row.pingfen == 10 ? 'pf-item active' : 'pf-item'
                  "
                >
                  优（10）
                </div>
                <div
                  :class="scope.row.pingfen == 8 ? 'pf-item active' : 'pf-item'"
                >
                  良（8）
                </div>
                <div
                  :class="scope.row.pingfen == 6 ? 'pf-item active' : 'pf-item'"
                >
                  一般（6）
                </div>
                <div
                  :class="scope.row.pingfen == 3 ? 'pf-item active' : 'pf-item'"
                >
                  差（3）
                </div>
              </div>
              <div class="pf-box" v-if="scope.row.sum == 20">
                <div
                  :class="
                    scope.row.pingfen == 20 ? 'pf-item active' : 'pf-item'
                  "
                >
                  优（20）
                </div>
                <div
                  :class="
                    scope.row.pingfen == 16 ? 'pf-item active' : 'pf-item'
                  "
                >
                  良（16）
                </div>
                <div
                  :class="
                    scope.row.pingfen == 12 ? 'pf-item active' : 'pf-item'
                  "
                >
                  一般（12）
                </div>
                <div
                  :class="scope.row.pingfen == 6 ? 'pf-item active' : 'pf-item'"
                >
                  差（6）
                </div>
              </div>
              <span v-if="scope.row.isShow">
                {{ scope.row.pingfen }}
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            font-size: 12px;
            color: #666;
            text-align: center;
            height: 60px;
            background: #eeeeee;
            border: 1px solid #eeeeee;
          "
        >
          <p style="line-height: 35px">
            优秀：完全胜任岗位要求(95-100分);
            <span style="margin-left: 20px"
              >良好：很好地达到岗位任职要求(80-95分);</span
            >
          </p>
          <p>
            一般：勉强达到岗位任职要求(60-80分);
            <span style="margin-left: 20px"
              >较差：明显不符合岗位任职要求(60 分以下)。</span
            >
          </p>
        </div>
      </div>
      <div class="box-title">
        <span>辅助材料</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div
        class="Materials"
        v-if="
          CreditEvaluation.contractList?.length > 0 ||
          CreditEvaluation.resumeList?.length > 0 ||
          CreditEvaluation.assistantList?.length > 0
        "
      >
        <div
          class="MaterialsDisplay"
          @click="handelDownload(CreditEvaluation.contractList)"
          v-if="CreditEvaluation.contractList?.length > 0"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>劳动合同</p>
        </div>
        <div
          class="MaterialsDisplay"
          @click="handelDownload(CreditEvaluation.resumeList)"
          v-if="CreditEvaluation.resumeList?.length > 0"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>简历</p>
        </div>
        <div
          class="MaterialsDisplay"
          v-for="(item, index) in CreditEvaluation.assistantList"
          :key="index"
          @click="handelViewTheMaterials(item)"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>{{ item.attaName }}</p>
        </div>
      </div>
      <div v-else class="Materials" style="font-size:14px"> -- </div>
      <div class="box-title">
        <span>意向</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="Intention">
        意向城市：
        <div class="ipt-box">{{ CreditEvaluation.intentionCity || "--" }}</div>
        意向职业：
        <div class="ipt-box">
          {{ CreditEvaluation.intentionPosition || "--" }}
        </div>
        意向行业：
        <div class="ipt-box">
          {{ CreditEvaluation.intentionIndustry || "--" }}
        </div>
      </div>
      <div class="box-title">
        <span>备注信息</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="Remarks">
        <!-- <p class="RemarksTime">{{ CreditEvaluation.createTime || "--" }}</p> -->
        <p class="RemarksCon">{{ CreditEvaluation.remark || "--" }}</p>
      </div>

      <div class="AddRegion">
        <p>追加内容</p>
      </div>
      <div class="box-title">
        <span>追加材料</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div class="Materials">
        <div class="Upload-box" v-loading="loading">
          <input
            type="file"
            ref="clearFile"
            @change="onFileChangeMaterials"
            id="file1"
          />
          <input
            type="button"
            value="+"
            class="btn"
            @click="clickFileMaterials(1)"
          />
        </div>
        <div
          class="MaterialsDisplay"
          v-for="(item, index) in AddDocIdArr"
          :key="index"
        >
          <img src="../../../../assets/imgs/wenjian@3x.svg" alt="" />
          <p>{{ item.attaName }}</p>
          <div class="deleIcon" @click="handelDeleNew(index)"></div>
        </div>
      </div>
      <div class="box-title">
        <span>追加备注</span>
        <img src="@/assets/imgs/zhuangshi@3x.svg" alt="" />
      </div>
      <div>
        <el-input
          type="textarea"
          resize="none"
          placeholder="请填写追加备注"
          v-model="textarea"
          maxlength="300"
          show-word-limit
          :autosize="{ minRows: 4, maxRows: 8 }"
        >
        </el-input>
      </div>
      <div class="agreement-text" style="font-size: 16px;margin: 20px 0;">
        追加即表示已阅读并遵守<span
          style="color: #409eff ; cursor: pointer;"
          @click="handelAgreement"
        >《职场信用管理规则》</span>
      </div>
      <div class="Publish">
        <p @click="handelPublish">追加</p>
      </div>
    </div>

    <ImgUpload
      :dialogUpload="dialogUpload"
      @handleCloseUpload="dialogUpload = false"
      @handleUpload="handleUpload"
      :Title="Title"
      :Attachment="Attachment"
    ></ImgUpload>
  </div>
</template>

<script>
import { postGetStsDowLoadPath } from "../../../../assets/api/index";
import ImgUpload from "./components/ImgUpload2.vue"; //上传

import {
  getCompanyEmployeeInfo, //次添加信用评价时回显员工基本信息以及附件
  editEmployeeAttachment, // 上传职场信用评价申请
  lookEmployeeCreditEvaluationByEmployeeId, //公司文件库中查看员工信用评价（正常查看/重新提交回显）
  appendCreditEvaluation, // 追加信用评价
} from "../../../../assets/api/firm/HumanResources";
import TenderVue from "../../firmHelp/HelpShop/moduleFour/Tender.vue";
export default {
  data() {
    return {
      addDocIdList:[],//修改评价申请书的数据只有点击发布时上传申请书并发布
      deleteDocIdList:[],//修改评价申请书的数据只有点击发布时上传申请书并发布
      loading: false,
      listArr: [], //辅助材料
      routeName: "",
      options: [],
      value: "",
      radio4: "上海",
      tableData: [
        {
          date: "基础能力",
          name: "业务知识",
          address:
            "是否充分具备现任职务所要求的基础知识和专业技能知识，是否具备丰富的本职工作经验，是否能够不断更新自己的专业知识",
          sum: 10,
          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "学习创新",
          address:
            "是否掌握系统的理论知识，能够将工作中的经验进行总结提炼并有所创新，并能够将所学传授他人",
          sum: 10,

          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "执行能力",
          address:
            "是否自觉遵守各项规章制度，是否依照既定的计划、原则和办法执行工作任务，关注细节，有意识地在工作中寻求规律技巧，提升工作效率与水平",
          sum: 10,

          pingfen: 0,
        },
        {
          date: "基础能力",
          name: "协同能力",
          address:
            "是否具有全局意识，能否主动为他人提供帮助，主动配合其他部门或岗位进行相关工作，善于与人沟通，能有效地化解工作中的矛盾",
          sum: 10,

          pingfen: 0,
        },
        {
          date: "工作任务",
          name: "工作效率",
          address:
            "能否在规定时间内较好地完成工作，是否除自觉完成本职工作外，还能承担分外的工作",
          sum: 20,
          pingfen: "",
        },
        {
          date: "工作任务",
          name: "工作成果",
          address: "能否按照事先拟定计划或目标保质保量地完成工作任务",
          sum: 20,
          pingfen: 0,
        },
        {
          date: "工作态度",
          name: "积极性和责任感",
          address:
            "工作是否积极主动;是否具有较高的责任感;是否严格遵守工作纪律和规章制度。",
          sum: 20,
          pingfen: 0,
        },
        {
          date: "合计",
          name: "合计",
          address: "合计1",
          sum: 0,
          pingfen: 0,
          isShow: true,
        },
      ],
      textarea: "", //备注

      dialogUpload: false, //上传职场信用评价申请
      Title: "职场信用评价申请",
      Attachment: {}, // 附件信息
      Information: {}, // 回显员工信息
      AddDocIdArr: [], //上传文件的id集合

      CreditEvaluation: {}, // 信用评价回显数据
    };
  },
  components: {
    ImgUpload,
  },
  created() {
    this.routeName = this.$route.name;
    this.handelTotal();
    this.getCompanyEmployeeInfo();
    this.lookEmployeeCreditEvaluationByEmployeeId();
  },
  methods: {
    // 点击协议查看协议详情
    handelAgreement() {
      const route = this.$router.resolve({
        path: "/AboutUs/Express",
        query: { name: "职场信用管理规则" },
      });
      window.open(route.href, '_blank');
    },
    // --------------- lookEmployeeCreditEvaluationByEmployeeId
    async lookEmployeeCreditEvaluationByEmployeeId() {
      var data = {
        data: {
          employeeId: this.$route.query.employeeId,
        },
      };
      // 调用 接口
      const res = await lookEmployeeCreditEvaluationByEmployeeId(data);
      this.tableData[0].pingfen = res.data.score.professionalKnowledge;
      this.tableData[1].pingfen = res.data.score.learningInnovation; //学习创新
      this.tableData[2].pingfen = res.data.score.executionAbility; //执行能力
      this.tableData[3].pingfen = res.data.score.synergy; // 协同
      this.tableData[4].pingfen = res.data.score.workingEfficiency; // 效率
      this.tableData[5].pingfen = res.data.score.workAchievements; // 成果
      this.tableData[6].pingfen = res.data.score.enthusiasm; // 积极性
      this.CreditEvaluation = res.data;
      this.handelTotal();
    },
    // 下载简历/合同/申请书
    handelDownload(val) {
      for (var k in val) {
        postGetStsDowLoadPath(val[k].docId).then((res) => {
          if (res.code == 0) {
            let a = document.createElement("a");
            a.href = res.data;
            a.click();
          }
        });
      }
    },
    // 查看资料大图
    handelViewTheMaterials(item) {
      postGetStsDowLoadPath(item.docId).then((res) => {
        if (res.code == 0) {
          let a = document.createElement("a");
          a.href = res.data;
          a.click();
        }
      });
    },
    // 上传确认
    handleUpload(val, val1) {
      

      // val 新增的图片id集合  val1老图片被删除的ID集合
      var data = {
        data: {
          employeeId: this.Information.employeeId, //员工id
          attaType: this.Title == "劳动合同" ? 1 : this.Title == "简历" ? 2 : 0, //操作的附件类型
          addDocIdList: val, //添加的id集合
          deleteDocIdList: val1, //删除的id集合
        },
      };
      if (val != 0 || val1 != 0) {
        editEmployeeAttachment(data).then((res) => {
          if (res.code == 0) {
            this.getCompanyEmployeeInfo();
            this.$tool.PromptBox("success", "操作成功");
          }
        });
      }

      this.dialogUpload = false;
    },
    // 追加
    handelPublish() {
      if (this.Information.applyForEvaluate != null) {
        const appendRemark =
          this.textarea != null ? String(this.textarea).trim() : "";
        console.log(this.AddDocIdArr, "this.AddDocIdArr ");
        if (this.AddDocIdArr.length < 1) {
          this.$tool.PromptBox("error", "请上传追加材料");
          return;
        }
        if (!appendRemark) {
          this.$tool.PromptBox("error", "请填写追加备注");
          return;
        }

        // 正常发布
        var data = {
          data: {
            creditId: this.CreditEvaluation.id,
            employeeId: this.Information.employeeId,
            appendRemark,
            attachmentList: this.AddDocIdArr,
          },
        };
        appendCreditEvaluation(data).then((res) => {
          this.AddDocIdArr = [];
          if (res.code == 0) {
            this.$tool.PromptBox("success", "操作成功");
            this.$router.push({
              path: "/Firm/talentFile/detail",
              query: {
                typeValue: 1,
                currentPage: 1,
                companyId: this.Information.companyId, // 企业id
                employeeId: this.Information.employeeId, //员工id
                leaveOrNot: 1,
              },
            });
          }
        });
      } else {
        this.$tool.PromptBox("warning", "请先上传职场信用申请书");
      }
    },

    //删除辅助材料
    handelDeleNew(index) {
      this.AddDocIdArr.splice(index, 1);
    },
    // 点击上传
    clickFileMaterials() {
      const input = document.querySelector("#file1");
      input.click();
    },
    // 调用上传文件/图片封装的js
    // 正面
    async onFileChangeMaterials(event, opt, callback) {
      console.log("上传材料");
      this.loading = true;
      var file = event.target.files[0] || event.dataTransfer.files[0];
      var fileSuffix1 = file.name;

      var arr = await this.$tool.onFileChangeNew(event, opt, callback);

      if (arr.code == 0) {
        this.loading = false;
        var obj = {
          attaType: 4,
          attaName: fileSuffix1,
          docId: arr.docId,
        };
        this.AddDocIdArr.push(obj);
      } else {
        this.loading = false;
      }
      this.$refs.clearFile.value = ""; // 清空file文件
    },
    // 合计
    handelTotal() {
      let sum = 0;
      this.tableData[this.tableData.length - 1].pingfen = 0;
      for (var i in this.tableData) {
        sum += this.tableData[i].pingfen * 1;
      }
      this.tableData[this.tableData.length - 1].pingfen = sum;
    },
    // ------------------ 次添加信用评价时回显员工基本信息以及附件
    async getCompanyEmployeeInfo() {
      var data = {
        data: {
          companyId: this.$route.query.companyId,
          id: this.$route.query.employeeId,
        },
      };
      // 调用 接口
      const res = await getCompanyEmployeeInfo(data);
      this.Information = res.data;
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      // 针对第一列（columnIndex === 0）
      if (columnIndex === 0) {
        // 前四行合并（rowIndex 0-3）
        if (rowIndex < 4) {
          // 第一行返回合并 4 行
          if (rowIndex === 0) {
            return { rowspan: 4, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else if (rowIndex < 6) {
          // 第五行单独显示
          if (rowIndex === 4) {
            return { rowspan: 2, colspan: 1 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        }
      }
      if (rowIndex === 7) {
        if (columnIndex < 3) {
          // 第一行返回合并 4 行
          if (columnIndex === 0) {
            return { rowspan: 1, colspan: 3 };
          } else {
            // 后续行隐藏
            return { rowspan: 0, colspan: 0 };
          }
        } else {
          return { rowspan: 1, colspan: 1 };
        }
      }
    },

    // 返回文件管理首页
    handelReturn() {
      this.$router.push({
        path: "/Firm/talentFile",
        query: {
          typeValue: 1,
          currentPage: 1,
        },
      });
    },
    // 返回上一页
    handelPreviousPage() {
      this.$router.push({
        path: "/Firm/talentFile/detail",
        query: {
          typeValue: 1,
          currentPage: 1,
          companyId: this.Information.companyId, // 企业id
          employeeId: this.Information.employeeId, //员工id
          leaveOrNot: 1,
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.firm-body {
  .box {
    width: 1200px;
    min-height: 700px;
    margin-top: 20px;
    padding: 10px 30px 30px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
    .box-title {
      width: 80px;
      height: 60px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        font-family: PingFangSC-Medium;
        font-size: 20px;
        color: #333333;
        font-weight: 400;
      }

      img {
        position: absolute;
        bottom: 10px;
        left: 0px;
      }
    }

    .information {
      height: 100px;
      background: #ffffff;
      border: 1px solid #eeeeee;
      border-radius: 5px;
      padding: 20px;
      display: flex;
      margin: 20px 0 10px;
      box-sizing: border-box;

      .left {
        width: 50%;
        display: flex;
        align-items: center;

        .left-img {
          width: 60px;
          margin-right: 40px;

          img {
            width: 100%;
          }
        }

        .left-text {
          font-size: 12px;
          color: #333333;
          font-weight: 400;

          span {
            margin-right: 20px;
          }
        }
      }

      .right {
        width: 50%;
        font-size: 12px;
        color: #333333;
        font-weight: 400;
      }
    }

    .pf-box {
      display: flex;
      align-items: center;
      width: 300px;
      box-sizing: border-box;
      border: 1px solid #409eff ;
      border-radius: 15px;
      overflow: hidden;
      margin: 0 auto;

      .pf-item {
        width: 25%;
        border-right: 1px solid #409eff ;
        text-align: center;
        cursor: pointer;
      }

      .pf-item:last-child {
        border-right: 0;
      }

      .active {
        background-color: #409eff ;
        color: #fff;
      }
    }
    .Publish {
      width: 100%;
      height: 40px;
      line-height: 40px;
      display: flex;
      justify-content: flex-end;
      margin-top: 30px;
      p {
        width: 120px;
        height: 40px;
        background: #409eff ;
        border-radius: 5px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        cursor: pointer;
      }
    }
    // 上传
    .Materials {
      width: 100%;
      // min-height: 100px;
      display: flex;
      flex-wrap: wrap;
      .Upload-box {
        border: 1px dashed #409eff ;
        width: 80px;
        height: 80px;
        background: #ffffff;
        border-radius: 5px;
        display: flex;
        margin-bottom: 10px;
        cursor: pointer;
        #file {
          display: none;
        }
        #file1 {
          display: none;
        }
        input {
          border: none;
          box-shadow: none;
          outline: none;
          background-color: transparent;
          width: 100%;
          text-align: center;
          color: #409eff ;
          margin: auto;
        cursor: pointer;
        }
      }
      .MaterialsDisplay {
        width: 80px;
        height: 80px;
        margin-left: 10px;
        margin-bottom: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        cursor: pointer;
        img {
          width: 40px;
          height: 50px;
          margin: auto;
        }
        p {
          width: 100%;
          height: 20px;
          line-height: 20px;
          text-align: center;
          font-size: 14px;
          color: #333333;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .deleIcon {
          width: 15px;
          height: 15px;
          background-image: url("../../../../assets/imgs/shanchu@3x.svg");
          background-size: 100% 100%;
          position: absolute;
          right: 5px;
          top: 5px;
        }
      }
    }
    // 意向
    .Intention {
      width: 100%;
      height: 35px;
      display: flex;
      margin-bottom: 20px;
      font-size: 14px;
      color: #333333;
      line-height: 35px;
      .ipt-box {
        width: 250px;
        margin-right: 50px;
      }
    }
    // 追加
    .AddRegion {
      width: 100%;
      height: 40px;
      display: flex;
      margin-top: 50px;
      p {
        width: 300px;
        height: 40px;
        background: #409eff ;
        border-radius: 10px;
        font-size: 16px;
        color: #ffffff;
        text-align: center;
        line-height: 40px;
        margin: auto;
      }
    }
    // 备注信息
    .Remarks {
      width: 100%;
      min-height: 60px;
      margin-bottom: 20px;
      font-size: 14px;
      .RemarksTime {
        color: #999999;
        margin-bottom: 10px;
      }
      .RemarksCon {
        color: #333333;
      }
    }
  }
}
/deep/.el-form-item .el-form-item__label {
  font-size: 14px;
}
/deep/.el-textarea .el-input__count {
  bottom: 0 !important;
}
/deep/.el-textarea__inner {
  font-size: 12px;
}
</style>
